import { Product } from './Product';

export class Selection {
    constructor(data) {
        this.product = data.product instanceof Product
            ? data.product
            : new Product(data.product);
        this.addedAt = data.addedAt;
    }

    get id() {
        return this.product.id;
    }

    get name() {
        return this.product.name;
    }

    get image() {
        return this.product.image;
    }

    get link() {
        return this.product.link;
    }

    get addedAtDate() {
        return new Date(this.addedAt);
    }

    toJSON() {
        return {
            product: this.product.toJSON(),
            addedAt: this.addedAt,
        };
    }
}
